import TableHead from '@mui/material/TableHead'
import { TableRowStyled, TableHeadStyled } from "../styling/tableStyles";

export default function TableNoSortHeader(props) { 
  const { heads } = props;
  const mheads = Array.isArray(heads[0]) ? heads : [ heads ];

  return (
    <>
      <TableHead>
        {mheads.map((hrow, r) => (
          <TableRowStyled key={r}>
            {hrow.map((th, c) => {
              if (!th.invisible) { 
                return (
                  <TableHeadStyled 
                    sx={th.hasOwnProperty("sx") ? th.sx : {}} 
                    rowSpan={th.hasOwnProperty("rowSpan") ? th.rowSpan : 1} 
                    colSpan={th.hasOwnProperty("colSpan") ? th.colSpan : 1} 
                    key={"c"+c}
                  >
                    {th.text}
                  </TableHeadStyled>
                )
              }
            })}
          </TableRowStyled>
        ))}
      </TableHead>
    </>
  )
}
